export default "__VITE_ASSET__Da5WnR6E__"